// API Configuration using environment variables with fallback to production API
const API_CONFIG = {
  baseURL: process.env.REACT_APP_API_BASE_URL || 'https://creativetown.ng',
  apiURL: process.env.REACT_APP_API_URL || 'https://creativetown.ng/api',
  protocol: 'https'
};

const config = API_CONFIG;

  // API Endpoints - centralized configuration
export const API_ENDPOINTS = {
  // Base URL for fallback cases
  BASE_URL: config.baseURL,

  // Authentication
  ADMIN_LOGIN: `${config.apiURL}/admin/login`,
  STUDENT_LOGIN: `${config.apiURL}/students/login`,
  TEACHER_LOGIN: `${config.apiURL}/admin/login`,
  STAFF_LOGIN: `${config.apiURL}/admin/login`,
  PARENT_LOGIN: `${config.apiURL}/parents/login`,

  // Data endpoints
  STUDENTS: `${config.apiURL}/students`,
  TEACHERS: `${config.apiURL}/teachers`,
  CLASSES: `${config.apiURL}/classes`,
  SUBJECTS: `${config.apiURL}/subjects`,
  TOPICS: `${config.apiURL}/topics`,
  LESSONS: `${config.apiURL}/lessons`,
  EXAMS: `${config.apiURL}/exams`,
  ASSIGNMENTS: `${config.apiURL}/assignments`,
  ATTENDANCE: `${config.apiURL}/attendance`,
  ATTENDANCE_GPS_SETTINGS: `${config.apiURL}/attendance/gps-settings`,
  FEES: `${config.apiURL}/fees`,
  PAYMENTS: `${config.apiURL}/payments`,
  GALLERY: `${config.apiURL}/gallery/media`,
  VIDEOS: `${config.apiURL}/videos`,
  GAMES: `${config.apiURL}/games`,
  MESSAGES: `${config.apiURL}/messages`,
  ANNOUNCEMENTS: `${config.apiURL}/announcements`,
  IDEAS: `${config.apiURL}/ideas`,
  EXPENSES: `${config.apiURL}/expenses`,
  SALARIES: `${config.apiURL}/salaries`,
  SECURITY: `${config.apiURL}/security`,
  SCREEN_TIME: `${config.apiURL}/screen-time`,
  SCHEDULES: `${config.apiURL}/schedules`,
  PROGRESS: `${config.apiURL}/students/progress`,
  ACHIEVEMENTS: `${config.apiURL}/students/achievements`,
  FEEDBACK: `${config.apiURL}/feedback`,
  ENROLLMENTS: `${config.apiURL}/enrollments`,
  STAFF: `${config.apiURL}/staff`,
  PARENTS: `${config.apiURL}/parents`,
  PROGRESS_MEDIA: `${config.apiURL}/progress-media`,
  TRACKING: `${config.apiURL}/tracking`,

  // File upload endpoints
  UPLOAD_PROFILE: `${config.apiURL}/students/profile-picture`,
  UPLOAD_TEACHER_PROFILE: `${config.apiURL}/teachers/profile-picture`,
  UPLOAD_STAFF_PROFILE: `${config.apiURL}/staff/profile-picture`,
  UPLOAD_GALLERY: `${config.apiURL}/gallery/upload`,
  UPLOAD_VIDEO: `${config.apiURL}/videos`,
  UPLOAD_GAME: `${config.apiURL}/games`,
  UPLOAD_LESSON_MEDIA: `${config.apiURL}/lessons/upload-media`,
  UPLOAD_RECEIPT: `${config.apiURL}/payments/receipt`,

  // Utility endpoints
  TEST: `${config.apiURL}/test`,
  DASHBOARD: `${config.apiURL}/admin/dashboard`,
  ANALYTICS: `${config.apiURL}/admin/analytics`,
  SETTINGS: `${config.apiURL}/admin/settings`
};

// Helper functions for URL generation
export const getImageUrl = (filePath) => {
  if (!filePath) return '';
  // Ensure HTTPS for all image URLs in production
  if (filePath.startsWith('http')) return filePath;
  return `${config.baseURL}${filePath}`;
};

export const getApiUrl = (endpoint) => {
  return API_ENDPOINTS[endpoint] || `${config.apiURL}${endpoint}`;
};

export const getBaseUrl = () => {
  return config.baseURL;
};

// API utility functions
export const apiPost = async (endpoint, data) => {
  const response = await fetch(API_ENDPOINTS[endpoint] || endpoint, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  });
  const payload = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(payload.error || 'Request failed');
  }
  return payload;
};

// Environment info
export const isSecure = config.protocol === 'https';
export const currentEnv = 'production'; // Always using production API now

// Default export
export default config;
